import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Radio from '../../../components/common/Radio';

const InstallmentModal = ({ installment, setInstallment }) => {
  const { t } = useTranslation('resultQuery');
  const { installmentData } = useSelector(state => state.resultQuery);
  const { myInfo } = useSelector(state => state.myInfo);
  const htmComCd = myInfo?.htmComCd || '';

  // 연말정산팀 요청으로 아래회사는 2개월 분납 추가 26.01.30 선희
  // NK: (주)넥슨코리아, NO: (주)네오플, GN: 주식회사 엔진스튜디오, SE: 주식회사 넥슨스페이스,
  // NW: (주)넥슨네트웍스, NMP: 주식회사 엔미디어플랫폼, NAT: 주식회사 넥슨게임즈,
  // NU: (주)넥슨커뮤니케이션즈, NT: 주식회사 니트로 스튜디오, DV: 주식회사 데브캣, UV: 주식회사 넥슨유니버스
  //HCS : 현대캐피탈, high1 : 하이원
  const twoMonthInstallmentCompanies = [
    'NK',
    'NO',
    'GN',
    'SE',
    'NW',
    'NMP',
    'NAT',
    'NU',
    'NT',
    'DV',
    'UV',
    'HCS',
    'high1',
    'mint',
  ];
  const showTwoMonthInstallment = twoMonthInstallmentCompanies.includes(htmComCd);

  const installmentOptions = [
    { label: t('after.installmentOption1'), value: '' }, //일괄납부
    ...(showTwoMonthInstallment ? [{ label: t('after.installmentOption2'), value: '2' }] : []), //2개월
    { label: t('after.installmentOption3'), value: '3' }, //3개월
  ];

  return (
    <div style={{ marginTop: '-10px', marginBottom: '30px' }}>
      {installmentOptions.map((option, index) => (
        <div key={index} className="installmentOption">
          <Radio
            key={option.value}
            label={option.label}
            checked={installment === option.value}
            onChange={() => setInstallment(option.value)}
            size="large"
          />
        </div>
      ))}
    </div>
  );
};

export default InstallmentModal;
